module.exports = __webpack_public_path__ + "img/horeca.7e202249.svg";